import classNames from 'classnames';

import MarkSafe from 'topmeteo/general/components/MarkSafe';

const LegendContentNode = document.getElementById('legend-content');

const LegendContent = LegendContentNode.innerHTML;

const Legend = ({show}) => (
    <MarkSafe
        Element="div"
        id="panel-legend"
        className={classNames('container', {show})}
        html={LegendContent}
    />
);

export default Legend;
